import { getXsrfToken } from '../api/getXsrfToken';
import { trackError } from '../tracking/errorTracker';
/**
 * Statuses that carry no signal worth logging: the session has gone (401), or
 * the retailer is not provisioned for invoicing (403), which is the norm for
 * most retailers.
 */
const EXPECTED_FAILURE_STATUSES = new Set([401, 403]);
/**
 * Pushes a customer's details to invoicing so its credit account does not sit
 * on stale values until the customer's next on-account sale.
 *
 * Fire-and-forget by design: invoicing is a downstream consumer of the save,
 * not part of it, so this never rejects. Failures are reported to the error
 * tracker — never to the merchant, who cannot act on them.
 */
export const syncCustomerToInvoicing = async ({ customerId, payload, }) => {
    var _a;
    try {
        const response = await fetch(`/api/2.0/invoicing/v1/customers/${encodeURIComponent(customerId)}/sync`, {
            method: 'POST',
            credentials: 'include',
            redirect: 'error',
            headers: {
                'x-xsrf-token': (_a = getXsrfToken()) !== null && _a !== void 0 ? _a : '',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        // A 2xx also covers "skipped, this customer has no credit account", which
        // is the expected outcome for a customer who has never bought on account.
        if (response.ok || EXPECTED_FAILURE_STATUSES.has(response.status)) {
            return;
        }
        trackError('[Invoicing] Failed to sync customer', {
            customerId,
            status: response.status,
            statusText: response.statusText,
        });
    }
    catch (error) {
        trackError('[Invoicing] Failed to sync customer', { customerId, error });
    }
};
